import { Button } from '@/lib/Buttons';
import { TranslationKeys } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type DeleteModalWithConfirmInputFooterProps = {
  canConfirm: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
  isLoading?: boolean;
  confirmText?: TranslationKeys;
  cancelText?: TranslationKeys;
};

export const DeleteModalWithConfirmInputFooter: FC<DeleteModalWithConfirmInputFooterProps> = ({
  canConfirm,
  onConfirm,
  onClose,
  isLoading = false,
  confirmText = 'COMMON:gotIt',
  cancelText = 'COMMON:cancel',
}) => {
  const { t } = useTranslation();

  return (
    <div className='flex gap-3'>
      <Button type='button' intent='secondary' text={t(cancelText as any)} onClick={onClose} className='size-full' disabled={isLoading} />
      <Button type='button' text={t(confirmText as any)} onClick={onConfirm} className='size-full' isLoading={isLoading} disabled={!canConfirm} />
    </div>
  );
};
